import type { BoardType } from "@/model/baseTypes";
import type { BoardData } from "@/model/board";

import { BacklogBoard } from "./BacklogBoard";
import type { BaseBoard } from "./BaseBoard";
import { FlexBoard } from "./FlexBoard";
import { ObjectivesBoard } from "./ObjectivesBoard";
import { ProgramBoard } from "./ProgramBoard";
import { RiskBoard } from "./RiskBoard";
import { SolutionBacklogBoard } from "./SolutionBacklogBoard";
import { SolutionBoard } from "./SolutionBoard";
import { TeamBoard } from "./TeamBoard";

export function boardOf<T extends BoardType>(board?: BoardData<T>): BaseBoard<BoardType> {
  switch (board?.type) {
    case "backlog":
      return new BacklogBoard(board);
    case "program":
      return new ProgramBoard(board);
    case "solution_backlog":
      return new SolutionBacklogBoard(board);
    case "solution":
      return new SolutionBoard(board);
    case "risk":
      return new RiskBoard(board);
    case "team":
      return new TeamBoard(board);
    case "flex":
      return new FlexBoard(board);
    case "objectives":
      return new ObjectivesBoard(board);
    case undefined:
      return new ObjectivesBoard(board as unknown as BoardData<"objectives">);
  }
}
